import { makeAutoObservable, runInAction } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  clearItemPatientAdvice,
  pagingPatientAdvise,
} from "app/services/PatientAdvice";
import { getFileById } from "app/services/FileDescriptionExtService";

export default class ListAdvise {
  searchAdvise = {
    ...new SearchObject(),
    fromDate: null,

    toDate:null,
  };
  pageAdvise = new PageResponse();
  openConfirmClearItemPatientAdvise = null;
  imageUrls = {};
  constructor() {
    makeAutoObservable(this);
  }
  pagingAdvise = async () => {
    let { departmentId, ...ortherData } = this.searchAdvise;
    if (departmentId && departmentId?.id) {
      ortherData.departmentId = departmentId?.id;
    }
    return await pagingPatientAdvise({ ...ortherData })
      .then(({ data }) => {
        this.pageAdvise = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };
  
  fetchImage = async (fileId) => {
    if (this.imageUrls[fileId]) return;

    try {
      const res = await getFileById(fileId);
      const imageUrl = URL.createObjectURL(res.data);
      runInAction(() => {
        this.imageUrls[fileId] = imageUrl;
      });
    } catch (error) {
      console.error("Lỗi tải ảnh:", error);
    }
  };

  getImageUrl = (fileId) => {
    return this.imageUrls[fileId];
  }


  handleChangeFormSearch = (searchAdvise) => {
    this.searchAdvise = { ...this.searchAdvise, ...searchAdvise };
    this.pagingAdvise();
  };
  handleClearItemPatientAdvise = (id) => {
    this.openConfirmClearItemPatientAdvise = id;
  };
  
  handleConfirmAdvise = () => {
    clearItemPatientAdvice(this.openConfirmClearItemPatientAdvise)
      .then(async ({ data }) => {
        this.handleClearItemPatientAdvise(null);
        if (data?.responseStatus === false) {
          toast.warning(data?.responseDetail);
          return;
        } else {
          this.pagingAdvise();
          toast.success("Xóa tư vấn thành công!");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa tư vấn có lỗi!");
      });
  };

  resetStore = () => {
    this.searchAdvise = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
    };
    this.pageAdvise = new PageResponse();
  };
}
